if (!customElements.get('jobski-image-slider')) {
  customElements.define('jobski-image-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.listeners = new AbortController();
      const signal = this.listeners.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.suppressClickUntil = 0;
      this.style.touchAction = 'pan-y pinch-zoom';
      this.querySelectorAll('img').forEach(img => { img.draggable = false; });
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.manualGo(-1), { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => this.manualGo(1), { signal });
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); }, { signal });
      this.addEventListener('touchstart', event => this.startTouch(event), { passive: true, signal });
      this.addEventListener('touchmove', event => this.moveTouch(event), { passive: false, signal });
      this.addEventListener('touchend', event => this.endTouch(event), { passive: true, signal });
      this.addEventListener('touchcancel', () => { this.gesture = null; }, { passive: true, signal });
      this.addEventListener('click', event => {
        if (Date.now() < this.suppressClickUntil && event.target.closest('[data-slide]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      this.updatePause();
      this.timer = setInterval(() => {
        if (!this.paused && !this.gesture && Date.now() >= (this.manualUntil || 0) && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.go(1);
      }, 6500);
    }
    startTouch(event) {
      this.gesture = null;
      if (event.touches.length !== 1 || this.slides.length < 2 || event.target.closest('button')) return;
      const touch = event.touches[0];
      this.gesture = { x: touch.clientX, y: touch.clientY, id: touch.identifier, axis: null };
    }
    moveTouch(event) {
      if (!this.gesture) return;
      if (event.touches.length !== 1) { this.gesture = null; return; }
      const touch = event.touches[0];
      if (touch.identifier !== this.gesture.id) return;
      const dx = touch.clientX - this.gesture.x;
      const dy = touch.clientY - this.gesture.y;
      if (!this.gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 12) {
        this.gesture.axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
      }
      if (this.gesture.axis === 'x') {
        if (event.cancelable) event.preventDefault();
        this.suppressClickUntil = Date.now() + 800;
      }
    }
    endTouch(event) {
      const gesture = this.gesture;
      this.gesture = null;
      if (!gesture || gesture.axis === 'y') return;
      const touch = [...event.changedTouches].find(t => t.identifier === gesture.id);
      if (!touch) return;
      const dx = touch.clientX - gesture.x;
      const dy = touch.clientY - gesture.y;
      const threshold = Math.max(35, Math.min(60, this.clientWidth * 0.1));
      if (Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.2) {
        this.suppressClickUntil = Date.now() + 800;
        this.manualGo(dx < 0 ? 1 : -1);
      }
    }
    manualGo(direction) {
      this.manualUntil = Date.now() + 8000;
      this.go(direction);
    }
    go(direction) {
      if (this.slides.length < 2) return;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      if (this.slides[this.index].matches('a')) this.slides[this.index].tabIndex = -1;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'false');
      if (this.slides[this.index].matches('a')) this.slides[this.index].tabIndex = 0;
      const count = this.querySelector('[data-count]');
      if (count) count.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.listeners?.abort();
      this.gesture = null;
      this.initialized = false;
    }
  });
}
